const ZOOM_STEPS = [0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3] as const;
const DEFAULT_ZOOM = 1;
const ZOOM_STORAGE_KEY = "nprice-zoom";

export { DEFAULT_ZOOM, ZOOM_STEPS, ZOOM_STORAGE_KEY };

export const getInitialZoom = (): number => {
  if (typeof window === "undefined") return DEFAULT_ZOOM;

  const savedZoom = Number(window.localStorage.getItem(ZOOM_STORAGE_KEY));
  return ZOOM_STEPS.includes(savedZoom as (typeof ZOOM_STEPS)[number])
    ? savedZoom
    : DEFAULT_ZOOM;
};
